import { gql } from "@apollo/client";

export default gql`
  query getProfileWeeklySummary($userId: Int!, $weekOffset: Int!) {
    profileWeeklySummary(userId: $userId, weekOffset: $weekOffset) {
      __typename
      weekStart
      weekEnd
      weekOffset
      subjectName
      insights {
        __typename
        id
        text
        sources {
          __typename
          id
          type
          provider
          title
          detail
          timestamp
          url
          isExternal
        }
      }
      activity {
        __typename
        id
        text
        sources {
          __typename
          id
          type
          provider
          title
          detail
          timestamp
          url
          isExternal
        }
      }
    }
  }
`;
